export const LINKS = {
    telegram: "https://t.me/visper_support_bot",
};

export const YANDEX_METRIKA_ID = 98778399;
